<template>
  <div class="flex flex-col gap-8">
    <span class="text-static-default-hi body-1">{{ label }}</span>

    <div class="bg-surface-default-low rounded-lg flex gap-4 p-4">
      <button
        v-for="option in options"
        :key="option.value"
        :class="[
          'rounded-md body-1 flex-1 cursor-pointer border-none px-16 py-8 transition-all duration-200',
          modelValue === option.value
            ? 'bg-surface-default-hi text-static-default-hi'
            : 'text-static-default-low bg-transparent hover:text-static-default-hi',
        ]"
        type="button"
        @click="selectOption(option.value)"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

/**
 * Why this custom component: the backend sends non boolean values for boolean attributes. They
 * actually send the translated word of the boolean value (oui/non, ja/nein, si/nada etc...)
 * Since there is now way to know which label is "true" or "false", this custom component allows
 * to select wether of the two options, without attributing a "true" or "false" to one of the options.
 */

const props = defineProps<{
  label: string
  options: {
    value: string
    label: string
  }[]
  modelValue: string
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

onMounted(() => {
  if (!props.modelValue && props.options.length > 0) {
    emit('update:modelValue', props.options[0].value)
  }
})

function selectOption(value: string) {
  emit('update:modelValue', value)
}
</script>
